import { Typography, IconButton } from "@mui/material";
import { IGenesysFile } from "../../../../interface/IMessage";
import renderFileTypeIcon from "../../../atoms/renderFileTypeIcon/renderFileTypeIcon";
import Grid from "@mui/material/Grid2";
import getFileName from "../../../../function/getFileName";
import getFileUrl from "../../../../function/getFileUrl";
import getFileSize, {
  getFormattedFileSize,
} from "../../../../function/getFileSize";
import FA__DownloadIcon from "../../../../assets/icons/arrow-down-to-line-light-full.svg";
import SvgIcon from "../../../atoms/icons/svgIcon/svgIcon";

const RenderMessageContent = ({
  content,
  sender,
}: {
  content: IGenesysFile | File | null;
  sender: "user" | "bot" | "system";
}) => {
  if (!content) return null;

  const url = getFileUrl(content);

  return (
    <Grid
      container
      spacing={2}
      sx={{
        fontSize: "0.75rem",
        fontWeight: "bold",
      }}
    >
      <Grid
        size={{ xs: 3 }}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {renderFileTypeIcon(content)}
      </Grid>

      <Grid size={{ xs: 7 }} container spacing={0}>
        <Grid
          size={{ xs: 12 }}
          sx={{
            wordBreak: "break-all",
            textAlign: "left",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color:
                sender === "user"
                  ? (theme) =>
                      theme.palette.widgetStyles.userChatBubble.textColor
                  : (theme) =>
                      theme.palette.widgetStyles.botChatBubble.textColor,
            }}
          >
            {getFileName(content)}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12 }} sx={{ textAlign: "left" }}>
          <Typography
            variant="caption"
            sx={{
              color:
                sender === "user"
                  ? (theme) =>
                      theme.palette.widgetStyles.userChatBubble.textColor
                  : (theme) =>
                      theme.palette.widgetStyles.botChatBubble.textColor,
            }}
          >
            {getFormattedFileSize(getFileSize(content))}
          </Typography>
        </Grid>
      </Grid>

      <Grid
        size={{ xs: 2 }}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {url && (
          <IconButton
            aria-label="download-file-button"
            href={url}
            download
            target="_blank"
          >
            <SvgIcon icon={FA__DownloadIcon} />
          </IconButton>
        )}
      </Grid>
    </Grid>
  );
};

export default RenderMessageContent;
